import { ComponentProps } from 'react';
import { chip } from './variants';
import { Icon } from '../../../../core/components/atoms/Icon';

interface ChipProps extends ComponentProps<'div'> {
  label: string;
  variant: 'default' | 'easy' | 'medium' | 'hard';
  icon?: string;
  defaultIcon?: boolean;
  disabled?: boolean;
  type?: 'filled' | 'outline';
  onClick?: VoidFunction;
}

const Chip = ({
  label,
  variant,
  icon,
  defaultIcon,
  disabled,
  className,
  type,
  onClick,
  ...props
}: ChipProps) => {
  const iconDifficulty = {
    easy: 'sentiment_very_satisfied',
    medium: 'sentiment_neutral',
    hard: 'sentiment_dissatisfied',
  };

  return (
    <div className={chip({ variant, disabled, type, clickable: !!onClick, className })} onClick={onClick} {...props}>
      {icon && <Icon Icon={icon} type='material' />}
      {defaultIcon && (
        <Icon
          Icon={iconDifficulty[variant as keyof typeof iconDifficulty]}
          type='material'
          className={disabled ? 'text-md text-mono-color-medium' : 'text-md'}
        />
      )}
      {label}
    </div>
  );
};

export default Chip;
